export function getSiteOptions(appName) {
  switch (appName) {
    case 'unisescoop':
      return {
        title: 'Serviço Nacional de Aprendizagem no Cooperativismo',
        description: '',
        favicon: '/themes/unisescoop/favicon.png',
        ogImage: '',
      };
    case 'encceja':
      return {
        title: 'Pré-Encceja',
        description: 'Prepare-se para o Exame Nacional para Certificação de Competências de Jovens e Adultos (Encceja). Cadastre-se agora na plataforma Pré-Encceja!',
        favicon: '/themes/encceja/favicon-32x32.png',
        ogImage: '/themes/encceja/og-image.png',
      };
    case 'siape':
      return {
        title: 'Siape',
        description: 'Nascemos para levar educação de qualidade para quem precisa, onde quer que seja.',
        favicon: '/themes/siape/favicon/favicon-32x32.png',
        ogImage: '/themes/siape/og-image.png',
      };
    case 'iesb':
      return {
        title: 'Estudologia IESB',
        description: 'A Estudologia é uma plataforma online que ajuda estudantes a aprenderem mais e melhor.',
        favicon: '/themes/iesb/favicon/favicon-32x32.png',
        ogImage: '/themes/iesb/og-image.png',
      };
    case 'pit':
      return {
        title: 'Piauí Instituto de Tecnologia',
        description: '',
        favicon: '/themes/pit/favicon/favicon-32x32.png',
        ogImage: '/themes/pit/og-image.png',
      };
    case 'quartosecretariado':
      return {
        title: '4º Secretariado',
        description: 'Somos uma iniciativa que busca pluralizar o acesso aos estudos para a carreira diplomática.',
        favicon: '/themes/quartosecretariado/favicon/favicon-32x32.png',
        ogImage: '/themes/quartosecretariado/og-image.jpg',
      };
    case 'retina':
      return {
        title: 'Retina • Cultura de inovação educacional',
        description: 'Somos uma iniciativa que busca pluralizar o acesso aos estudos para a carreira diplomática.',
        favicon: '/themes/retina/favicon/favicon-32x32.png',
        ogImage: '/themes/retina/og-image.jpg',
      };
    case 'fic':
      return {
        title: 'FIC • Desenvolvimento de games e empreendedorismo',
        description: 'Somos uma iniciativa que busca pluralizar o acesso aos estudos para a carreira de games e empreendedorismo.',
        favicon: '/themes/fic/favicon/favicon-32x32.png',
        ogImage: '/themes/fic/og-image.jpg',
      };
    case 'brasilstartups':
      return {
        title: 'Brasil Startups',
        description: 'SEJA UM PROTAGONISTA NO ECOSSISTEMA DE INOVAÇÃO.',
        favicon: '/themes/brasil-startups/favicon/favicon-32x32.png',
        ogImage: '/themes/brasil-startups/og-image.jpg',
      };

    case 'canaleducacao':
      return {
        title: 'Canal Educação',
        description: 'Nascemos para levar educação de qualidade para quem precisa, onde quer que seja.',
        favicon: '/themes/canaleducacao/favicon/favicon-32x32.png',
        ogImage: '/themes/canaleducacao/og-image.jpg',
      };
    case 'egepi':
      return {
        title: 'Escola do Governo do Piauí',
        description: 'Nascemos para levar educação de qualidade para quem precisa, onde quer que seja.',
        favicon: '/themes/egepi/favicon/favicon-32x32.png',
        ogImage: '/themes/egepi/og-image.jpg',
      };

    case 'vegalabs':
      return {
        title: 'Vega Labs',
        description: 'Nascemos para levar educação de qualidade para quem precisa, onde quer que seja.',
        favicon: '/themes/vegalabs/favicon/favicon-32x32.png',
        ogImage: '/themes/vegalabs/og-image.jpg',
      };

    case 'inkluziva':
      return {
        title: 'Inkluziva',
        description: 'Nascemos para levar educação de qualidade para quem precisa, onde quer que seja.',
        favicon: '/themes/inkluziva/favicon/favicon-32x32.png',
        ogImage: '/themes/inkluziva/og-image.jpg',
      };
    case 'seducpi':
      return {
        title: 'Seduc PI',
        description: 'Nascemos para levar educação de qualidade para quem precisa, onde quer que seja.',
        favicon: '/themes/seducpi/favicon/favicon-32x32.png',
        ogImage: '/themes/seducpi/og-image.jpg',
      };
    case 'maiseducacao':
      return {
        title: 'Mais Formação',
        description: 'Nascemos para levar educação de qualidade para quem precisa, onde quer que seja.',
        favicon: '/themes/maisformacao/favicon/favicon-32x32.png',
        ogImage: '/themes/maisformacao/og-image.jpg',
      };
    case 'tjpara':
      return {
        title: 'Tribunal de Justiça do Estado do Pará',
        description: 'Tribunal de Justiça do Estado do Pará.',
        favicon: '/themes/tjpara/favicon/favicon-32x32.png',
        ogImage: '/themes/tjpara/og-image.jpg',
      };
    case 'powerforgirls':
      return {
        title: 'Power 4 Girls • Empower to lead!',
        description: 'Somos uma iniciativa que busca pluralizar o acesso aos estudos para a carreira diplomática.',
        favicon: '/themes/powerforgirls/favicon/favicon-32x32.png',
        ogImage: '/themes/powerforgirls/og-image.jpg',
      };
    case 'caboverde':
      return {
        title: 'Cabo Verde',
        description: 'Governo de Cabo Verde',
        favicon: '/themes/caboverde/favicon/favicon-32x32.png',
        ogImage: '/themes/caboverde/og-image.svg',
      };

    default:
      return {
        title: 'Estudologia Demo',
        description: 'A Estudologia é uma plataforma online que ajuda estudantes a aprenderem mais e melhor.',
        favicon: '/themes/demo/favicon/favicon-32x32.png',
        ogImage: '/themes/demo/og-image.png',
      };
  }
}
